import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FooterComponent } from '../../shared/components/footer/footer/footer.component';
import { HeaderComponent } from '../../shared/components/header/header/header.component';
import { AdsPlateform, SiteSettings } from '../../shared/dto/response/site.settings';
import { Config, Theme } from '../../shared/dto/response/template.config';
import { DraftRtConfigService } from '../../shared/service/draft-rt-config.service';
import { PixelService } from '../../shared/service/pixel.service';
import { StoreBrandingService } from '../../shared/service/store-branding.service';
import { TemplateConfigService } from '../../shared/service/template-config.service';
import { GetAllCountries } from '../../shared/store/actions/master.action';
import { GetShoppingCart } from '../../shared/store/actions/shoppingCart.action';
import { GetSiteSetting } from '../../shared/store/actions/siteSetting.action';
import { GetTemplateConfig } from '../../shared/store/actions/templateConfig.action';
import { SiteSettingState } from '../../shared/store/states/siteSetting.state';
import { TemplateConfigState } from '../../shared/store/states/templateConfig.state';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, AsyncPipe, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  @Select(TemplateConfigState.templateConfig)
  templateConfig$: Observable<Config>;

  @Select(TemplateConfigState.templateTheme)
  templateTheme$: Observable<Theme>;

  @Select(TemplateConfigState.siteId) siteId$: Observable<string>;

  @Select(SiteSettingState.siteSetting) siteSetting$: Observable<SiteSettings>;


  constructor(
    private router: Router,
    private store: Store,
    private pixelSvc: PixelService,
    private draftConfigService: DraftRtConfigService,
    private storeBranding: StoreBrandingService,
    private templateConfigService: TemplateConfigService,
    private translate: TranslateService,
    private destroyRef: DestroyRef

  ) {
    this.store.dispatch(new GetTemplateConfig());
    this.store.dispatch(new GetAllCountries());
    this.siteId$.subscribe((siteId) => {
      if (siteId && siteId != '') {
        this.store.dispatch(new GetSiteSetting());
        console.log('retrieving cart by siteId ', siteId);
        this.store.dispatch(new GetShoppingCart());
        draftConfigService.init(siteId);
        // ici on ne peut init Google que quand on a les settings ↓
        this.siteSetting$.subscribe(setting => {
          if (!setting) return;

          // Init Google (GA4 interne + GA4 custom + Ads GOOGLE)
          this.pixelSvc.initGoogleTags(setting, siteId);

          // Init autres pixels (comme avant)
          if (setting.ads_manager && setting.ads_manager.pixels) {
            setting.ads_manager.pixels.forEach(element => {
              switch (element.platform) {
                case AdsPlateform.META:
                  this.pixelSvc.loadFacbookPixel(element.id);
                  break;
                case AdsPlateform.TIKTOK:
                  this.pixelSvc.loadTiktokPixel(element.id);
                  break;
                case AdsPlateform.GOOGLE:
                  // rien ici : gtag déjà initialisé via initGoogleTags
                  break;
                default:
                  break;
              }
            });
          }
        });

      }
    });

    // Cambio de idioma de contenido: re-fetch del carrito (nombres/etiquetas
    // traducidos). ShoppingCartState.getShoppingCart() ya es un no-op seguro si aún no
    // hay cart_id. Una sola suscripción aquí cubre todas las superficies que leen
    // ShoppingCartState.shoppingCart (carrito, header, resumen de checkout).
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.store.dispatch(new GetShoppingCart());
    });

    this.templateTheme$.subscribe(theme => {
      if (theme) {
        this.loadStyle(theme);
      }
    })

    // Titulo de pestana y favicon con la identidad de la tienda. Se hace despues de que
    // el tema este cargado para que el monograma tome el --theme-color correcto.
    this.siteSetting$.subscribe(setting => {
      if (!setting) return;
      this.storeBranding.apply(setting.site_name, this.resolveHeaderLogo());
    });
    this.loadStyleLocalTEst()
  }

  /**
   * El logo vive en las secciones del header, dentro de la propiedad 'logo' del
   * SectionConfig — el mismo sitio del que tira HeaderLogoComponent. Devuelve null si la
   * tienda no tiene logo, y entonces el favicon cae al monograma.
   */
  private resolveHeaderLogo(): string | null {
    const config = this.store.selectSnapshot(TemplateConfigState.templateConfig);
    const sections = config?.header?.sections ?? [];
    for (const section of sections) {
      const logo = this.templateConfigService.findConfig(section?.config, 'logo');
      const value = logo?.options?.['logo']?.value;
      if (value) {
        return value;
      }
    }
    return null;
  }

  loadStyle(theme: Theme) {
    const head = document.getElementsByTagName('head')[0];

    const style = document.createElement('link');
    style.id = theme.id;
    style.rel = 'stylesheet';
    style.href = theme.path;
    //style.href = "assets/style/settings/variables.css";

    head.appendChild(style);
  }

  loadStyleLocalTEst() {
    const head = document.getElementsByTagName('head')[0];

    const style = document.createElement('link');
    style.id = "toto";
    style.rel = 'stylesheet';
    style.href = "assets/scss/themes/test.css";
    // //style.href = "assets/style/settings/variables.css";

    head.appendChild(style);
    // document.body.classList.add("dark");

    // if ('rtl'=='rtl') {
    //   document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    //   document.body.classList.add('rtl');
    // } else {
    //   document.getElementsByTagName('html')[0].removeAttribute('dir');
    //   document.body.classList.remove('rtl');
    // }

  }
  ngOnInit() {

  }
}
